import React from "react";
import { FormSectionElements, FormSubSections, ProgramContainer } from "../../entities/formTemplateDataType";
import { getRootComponent } from "../../utilities/ElementUtils";

type Props = {
    isEng: boolean;
    field: FormSectionElements;
    subsecToSummarize: FormSubSections;
    numberOfDuplicates: number;
    duplicateSubsecIndex: number;
    callbackStepIndex: (index: number) => void;
}

const EditSubsectionSummaryComponent = ({isEng, field, subsecToSummarize, numberOfDuplicates, duplicateSubsecIndex, callbackStepIndex}: Props) => {

    const arrayToString = (_a) => {
        if (Array.isArray(_a)) {
        return _a.join(' ');
        } else {
        return [_a]
        }
    }

    const editAction = () => {
        let section = subsecToSummarize.parent;
        let programContainer: ProgramContainer = getRootComponent(subsecToSummarize);
        section.ListOfFormSubSections.forEach(s => {
              if (s.ENUTitle == field.parent.SummarizeDuplicateSubsection) {
                // When KeepDuplicatesEditable is enabled, set ALL subsections to editable
                // Otherwise, only allow one editable at a time (original behavior)
                s.ReadOnlyElements = s.KeepDuplicatesEditable === true ? false : true;
              }
            });
        subsecToSummarize.ReadOnlyElements = false;
        callbackStepIndex(programContainer.ListOfFormSections.findIndex(s => s == section));
    }

    return(
        <button className={"ontario-button " + arrayToString(field.ClassName)} onClick={editAction}>
          {isEng ? field.ENUTitle : field.FRATitle} {(numberOfDuplicates >= 1) ? (duplicateSubsecIndex + 1).toString() : null}
        </button>
    );
}

export default EditSubsectionSummaryComponent;